import { FC, memo } from 'react'
import { useDisclosure } from '@chakra-ui/react'

import { FilterTemplate } from 'components'
import { ActivityFilter } from 'Activities/types'
import { SubmitedFilterDates } from 'components/miscellaneous/CalendarFilter'
import CalendarFilterTemplateProvider from './contexts/CalendarFilterTemplateManager/Provider'
import DataFilterFeedback from './components/DataFilterFeedback'
import CalendarFilterTemplateContent from './Content'

type Props = {
  title: string
  description: string
  filter: ActivityFilter
  onSubmitFilter: (values: SubmitedFilterDates) => void
}

const CalendarFilterTemplate: FC<Props> = ({ filter, title, description, onSubmitFilter }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  return (
    <CalendarFilterTemplateProvider onSubmitFilter={onSubmitFilter}>
      <FilterTemplate
        title={title}
        description={description}
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        contentWhenClosed={<DataFilterFeedback activityFilter={filter} p={4} />}
        content={<CalendarFilterTemplateContent filter={filter} />}
      />
    </CalendarFilterTemplateProvider>
  )
}

export default memo(CalendarFilterTemplate)
